import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {Table, ProjectIndicator, Checkbox} from 'web-components';
import {InvoiceTable, InvoiceTableHeader} from '../../../../styles/v2/invoice_modals_v2_styled';
import Util from '../../../../forecast-app/shared/util/util';

const InvoiceProjectsTable = ({projects, budgetType, selectedProjectsIds, onProjectSelect, onSelectAll}) => {
	const [expanded, setExpanded] = useState(true);

	const intl = useIntl();

	const tableData = {rows: projects};

	const toggleExpanded = () => {
		setExpanded(!expanded);
	};

	return projects?.length ? (
		<InvoiceTable>
			<InvoiceTableHeader>
				<div className={'expand-section ' + (expanded ? '' : 'collapsed')} onClick={toggleExpanded}>
					<div className={'headline'}>{budgetType}</div>
					<div className="controls">
						<div className={'expand-control' + (expanded ? ' expand' : ' collapse')} />
					</div>
				</div>
			</InvoiceTableHeader>
			{expanded ? (
				<Table>
					<Table.Header>
						<Table.HeaderColumn align="left" visible={true} width="EXTRA_SMALL">
							<Checkbox
								checked={projects.some(project => selectedProjectsIds && selectedProjectsIds.includes(project.id))}
								hasEntitiesChecked={!projects.every(project => selectedProjectsIds && selectedProjectsIds.includes(project.id)) && projects.some(project => selectedProjectsIds && selectedProjectsIds.includes(project.id))}
								onClick={() => onSelectAll(projects.map(p => p.id))}
							/>
						</Table.HeaderColumn>
						<Table.HeaderColumn align="left" visible={true} width="EXTRA_SMALL">
							<Table.HeaderColumn.Title>{intl.formatMessage({id: 'common.project_id_short'})}</Table.HeaderColumn.Title>
						</Table.HeaderColumn>
						<Table.HeaderColumn align="left" visible={true} width="MEDIUM" flex={1} usePadding>
							<Table.HeaderColumn.Title>{intl.formatMessage({id: 'common.project'})}</Table.HeaderColumn.Title>
						</Table.HeaderColumn>
						<Table.HeaderColumn align="left" visible={true} width="MEDIUM" usePadding>
							<Table.HeaderColumn.Title>{intl.formatMessage({id: 'common.client'})}</Table.HeaderColumn.Title>
						</Table.HeaderColumn>
						<Table.HeaderColumn align="right" visible={true} width="MEDIUM" usePadding>
							<Table.HeaderColumn.Title>{intl.formatMessage({id: 'project_budget.billable_hours'})}</Table.HeaderColumn.Title>
						</Table.HeaderColumn>
						<Table.HeaderColumn align="right" visible={true} width="MEDIUM" usePadding>
							<Table.HeaderColumn.Title>{intl.formatMessage({id: 'expenses.billable_expenses'})}</Table.HeaderColumn.Title>
						</Table.HeaderColumn>
					</Table.Header>
					<Table.Rows data={tableData} canExpand={false}>
						{({rowData, tableColumnsProps}) => {
							return (
								<Table.Row {...tableColumnsProps}>
									<Table.Column>
										<Checkbox checked={selectedProjectsIds.includes(rowData.id)} onClick={() => onProjectSelect(rowData.id)} />
									</Table.Column>
									<Table.Column>
										<ProjectIndicator name={rowData.name} id={rowData.companyProjectId} project={rowData} showProjectName={false} />
									</Table.Column>
									<Table.Column>{rowData.name}</Table.Column>
									<Table.Column>{rowData.client?.name}</Table.Column>
									<Table.Column>{Util.getFormattedNumberWithCurrency(Util.GetCurrencySymbol(rowData.currency), rowData.uninvoicedPrice + rowData.uninvoicedFixedPrice, intl)}</Table.Column>
									<Table.Column>{Util.getFormattedNumberWithCurrency(Util.GetCurrencySymbol(rowData.currency), rowData.uninvoicedExpenses, intl)}</Table.Column>
								</Table.Row>
							);
						}}
					</Table.Rows>
				</Table>
			) : null}
		</InvoiceTable>
	) : null;
};

export default InvoiceProjectsTable;
